export default "__VITE_ASSET__6f99ad91__"